import axios from 'axios'
import log from '../../log'
import simpleCacheBust from '../../utilities/simpleCacheBust'
import config from '../../config'
import { isPreviewUrl } from '../../utilities/routeHelpers'

const {
  apiSite,
  useCacheBuster
} = config

/**
 * Get information about a provided url/path/slug
 * @param {String} path the slug to lookup
 * @param {Object} [opts] options object
 * @param {*} [opts.cancelToken] axios cancel token
 */
export const getSlug = async (path, {
  cancelToken
} = {}) => {
  try {
    const { data } = await axios({
      operationId: 'getSlug',
      method: 'get',
      baseURL: apiSite,
      url: '/data-api/v1/slug',
      params: {
        path,
        ...(useCacheBuster.getSlug ? {
          cacheBuster: simpleCacheBust()
        } : {})
      },
      cancelToken: cancelToken
    })
    if (isPreviewUrl()) {
      if (data?.data?.current_dataset?.vid) {
        const vid = data?.data?.current_dataset?.vid
        if (vid) {
          const url = new URL(window.location.href)
          url.searchParams.set('vid', vid)
          window.history.replaceState(null, '', url.toString())
        }
      }
    }
    return data
  } catch (error) {
    log.error('getSlug: request error', error)
    throw (error)
  }
}
